export default {
  rebook: {
    bannerText: 'Keine Zahlung für Umbuchung erforderlich',
    bannerTextAlreadyHandled:
      'Diese Veranstaltung wurde bereits umgebucht oder abgesagt',
    confirmButtonLabel: 'Auswählen und umbuchen',
    requestRefundButtonLabel: 'Erstattung anfordern',
    contactSupportButtonLabel: 'Hilfe benötigen? Support kontaktieren',

    eventCard: {
      originalDate: 'Ursprünglicher Termin: {date}',
    },

    success: {
      title: 'Dein Erlebnis wurde umgebucht',
      subtitle: 'Wir haben Dir Deine Bestellbestätigung per E-Mail zugesandt.',
      nextSteps: {
        title: 'Nächste Schritte:',
        step1: {
          title: 'Du erhältst eine E-Mail von uns',
          subtitle: 'Um zu bestätigen, dass Deine Umbuchung erfolgreich war',
        },
        step2: {
          title: 'Gehe in Deinen Kontobereich um zu überprüfen',
          subtitle:
            'Sobald Deine Umbuchung bestätigt ist, kannst Du Deinen Kontostand und Deine nächsten Buchungen ganz einfach in Deinem Kontobereich überprüfen.',
        },
      },
      CTATitle: 'Zurück zu konfetti',
    },

    refund: {
      modal: {
        title: 'Möchtest Du wirklich stornieren statt umbuchen?',
        description:
          'Wenn Du stornierst, wird Dir der Betrag zurückerstattet – entweder auf Deine ursprüngliche Zahlungsmethode oder als Guthaben auf Dein Kundenkonto.',
        balanceButtonLabel: 'Rückerstattung auf Kundenkonto',
        gatewayButtonLabel: 'Rückerstattung auf Zahlungsmethode',
        contactSupportButtonLabel:
          'Brauchst Du Hilfe? Klicke hier, um den Support zu kontaktieren',
      },
      success: {
        balance: {
          title: 'Deine Rückerstattung war erfolgreich',
          description:
            'Wir werden Dich per E-Mail kontaktieren, um Deine Rückerstattung zu bestätigen.',
          nextSteps: {
            step1: {
              title: 'Nutze Dein Kontoguthaben jederzeit',
              subtitle:
                'Füge ein beliebiges Produkt zum Warenkorb hinzu, Du kannst aus über {eventCount} Events wählen.',
            },
            step2: {
              title: 'Automatisch angewendet',
              subtitle:
                'Dein Kontoguthaben wird automatisch an der Kasse angewendet.',
            },
          },
        },
        gateway: {
          title: 'Wir bearbeiten Deine Rückerstattung',
          description:
            'Wir werden Dich per E-Mail kontaktieren, um Deine Rückerstattung zu bestätigen.',
          nextSteps: {
            step1: {
              title: 'Du erhältst Deine Rückerstattung in Kürze',
              subtitle:
                'Bitte beachte, dass der Prozess je nach Bank 2 bis 5 Werktage dauern kann.',
            },
            step2: {
              title: 'Wir hoffen, Dich bald wiederzusehen!',
              subtitle:
                'Wir hoffen, Dich bald wiederzusehen! Nach der Bearbeitung Deiner Rückerstattung kannst Du gerne auf konfetti nach zukünftigen Events suchen, die Dich interessieren könnten.',
            },
          },
        },
      },
    },
  },
}
